module.exports = __webpack_public_path__ + "img/horiz_logo.f8eb2098.png";